module.exports = [
  '$resource',
  'Subscriptions',
  function PatientResource(
    $resource,
    Subscriptions,
  ) {
    const ResourceObject = $resource('/api/v2/patients/:id',
      {
        id: '@id',
      },
      {
        get: {
          method: 'GET',
          url: '/api/v2/patients/subscriptions',
          transformResponse: (data) => {
            let responseData = angular.fromJson(data);

            responseData = _.extend(responseData.subscriptions[0].patient, {
              profile: responseData.subscriptions[0].profile,
              subscription: new Subscriptions(_.omit(responseData.subscriptions[0], ['patient', 'profile'])),
            });

            return responseData;
          },
        },
      },
    );

    angular.extend(ResourceObject.prototype, {
      $clone(value) {
        return new ResourceObject(Object.assign(value || {}, this));
      },
    });

    return ResourceObject;
  },
];



// WEBPACK FOOTER //
// ./main/factories/patient-resource.js